module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/notes-c7db451094f35ad2e6a5377605359b21.svg";